import React, { useState } from "react";

import "./App.scss";
import "./index.scss";

import Authenticated from "./auth/GCMAuthenticationProvider";
import Main from "./components/Main";
import { initGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

export default function App() {
    initGlobalStates("gcm");

    return (
        <Authenticated>
            <Main />
        </Authenticated>
    );
}
